import React, { useState } from 'react'
import { RadioButton } from '@paypalcorp/pp-react'
import { UITabs } from '../components/layout'
import TestScenarios from './TestScenarios'

const countryOptions = [
  { label: 'United State', value: 'us' },
  { label: 'Great Britain', value: 'gb' },
  { label: 'France', value: 'fr' },
]

const ThreeDSTestScenarios = () => {
  const [selectedCountry, setSelectedCountry] = useState(
    countryOptions[0].value,
  )

  const handleChange = (e: any) => {
    const optedCountry = e?.target?.value
    setSelectedCountry(optedCountry)
  }

  return (
    <div>
      <UITabs id="acceptpaymenttabs">
        <div label="3DS 2.2">
          <RadioButton
            id="rb-country"
            label="Country"
            name="country"
            value={selectedCountry}
            onChange={(e) => handleChange(e)}
            options={countryOptions}
            style={{ marginBottom: '1.5rem' }}
          />
          <TestScenarios country={selectedCountry} type="3ds2" />
        </div>
        <div label="3DS 1.0">
          <TestScenarios type="3ds1" />
        </div>
      </UITabs>
    </div>
  )
}

export default ThreeDSTestScenarios
